import React from 'react'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { SalePersonItem } from './SalePersonItem'

/**
 * @typedef {import('../../../definitions').SalePerson} SalePerson
 */

/**
 * @typedef {Object} SalesPersonsProps
 * @property {SalePerson[]} salesPersons
 * @property {string=} title
 */

/**
 * Sales persons information.
 * @param {SalesPersonsProps} props
 * @return {JSX.Element}
 */
export const SalesPersons = ({ salesPersons, title = '' }) => {
  return (
    <Box className="sales-persons">
      {title && (
        <Typography variant={'h3'}>{title}</Typography>
      )}
      <div className="sales-persons__items">
        {salesPersons.map((salePerson, index) => {
          return (
            <SalePersonItem salePerson={salePerson} key={index} />
          )
        })}
      </div>
    </Box>
  )
}
